import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { pathHome } from '../../path';
import styles from './group-home-page.module.css';
import { useDispatch, useSelector } from 'react-redux';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import {
  addDateStartGroupBd,
  addDocBd,
  getDocBd,
  getGrupListDb,
  toggleGroupAccessAllBD,
} from '../../firebase';
import { addGroupRedux, toggleGroupAccessAllredux } from '../../store/slices/groupsSlice';
import { getGroupForId, getGroupName } from '../../helperProject';
import GroupSetting from '../../components/GroupSetting/GroupSetting';
import { SettingSvg } from '../../SVGComponents/SVGComponents';

export default function GroupHomePage() {
  const dispatch = useDispatch();
  let { group_id } = useParams();

  const [loaderPage, setLoaderPage] = useState(false);
  const [viberGroupLink, setViberGroupLink] = useState('');
  const [telegramGroupLink, setTelegramGroupLink] = useState('');
  const [copyGroupIdTrue, setCopyGroupIdTrue] = useState('');
  const [accessGroupAll, setAccessGroupAll] = useState(false);
  const [startDateGroup, setStartDateGroup] = useState('');
  const [shuowGroupSetting, setShowGroupSetting] = useState(false);

  const groups = useSelector((state) => state.groups.groupsList);

  // console.log('render GroupHomePage');

  const isActiveAccessAll = (groups, group_id) => {
    const groupObject = getGroupForId(groups, group_id);

    if (groupObject && groupObject.group.groupAccessAll) {
      setAccessGroupAll(true);
      dispatch(toggleGroupAccessAllredux({ index: groupObject.index, value: true }));
      return;
    }
    if (groupObject && !groupObject.group.groupAccessAll) {
      setAccessGroupAll(false);
      dispatch(toggleGroupAccessAllredux({ index: groupObject.index, value: false }));
    }
  };

  useEffect(() => {
    // console.log('render GroupHomePage/useEffect');
    setLoaderPage(true);
    const fetchData = async () => {
      if (!groups.length) {
        const groupsListArray = await getGrupListDb();
        dispatch(addGroupRedux(groupsListArray));
        isActiveAccessAll(groupsListArray, group_id);
      } else {
        isActiveAccessAll(groups, group_id);
      }
      const groupsLinks = await getDocBd('groupsLinks', group_id);
      const groupStartDate = await getDocBd('groupStartDate', group_id);

      if (groupsLinks) {
        setViberGroupLink(groupsLinks.viberGroupLink);
        setTelegramGroupLink(groupsLinks.telegramGroupLink);
      }
      if (groupStartDate) {
        setStartDateGroup(groupStartDate.groupStartDate);
      }

      setLoaderPage(false);
    };

    fetchData();
  }, []);

  const addLinksGroups = async (value) => {
    setLoaderPage(true);

    const ifAddLinksGroups = addDocBd('groupsLinks', group_id, value);

    if (ifAddLinksGroups) {
      alert('Додано успішно.');
    } else {
      alert('Помилка!!!');
    }

    setLoaderPage(false);
  };

  const copyGroupId = (group_id) => {
    navigator.clipboard
      .writeText(group_id)
      .then(() => {
        setCopyGroupIdTrue(group_id);
        setTimeout(() => {
          setCopyGroupIdTrue(false);
        }, 700);
      })
      .catch((err) => {
        alert('Не вдалося Скопіювати!');
        console.log(err);
      });
  };

  // При реєстрації дає дозвіл до меню
  const accessAll = (group_id) => {
    const toggleGroupAccessAll = async (groupId, access) => {
      setLoaderPage(true);

      let isAccess = window.confirm('Змінити доступ до меню?');
      if (isAccess) {
        const isToggle = await toggleGroupAccessAllBD(groupId, access);
        if (isToggle) {
          const groupObject = getGroupForId(groups, groupId);
          setAccessGroupAll(access);
          dispatch(toggleGroupAccessAllredux({ index: groupObject.index, value: access }));
        } else {
          setLoaderPage(false);
          return;
        }
      }
      setLoaderPage(false);
    };

    if (accessGroupAll) {
      toggleGroupAccessAll(group_id, false);
    }
    if (!accessGroupAll) {
      toggleGroupAccessAll(group_id, true);
    }
  };

  const addDateStartGroup = async (date) => {
    setLoaderPage(true);
    let isAddDate = window.confirm('Змінити дату?');

    if (isAddDate) {
      await addDateStartGroupBd(group_id, date);
      setStartDateGroup(date);
    }
    setLoaderPage(false);
  };

  return (
    <>
      <div className={styles.header_wrapper}>
        <Link className={styles.header_link} to={`/${pathHome}/home`}>
          <svg
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 9L11.25 0.339745V17.6603L0 9Z" fill="white" />
          </svg>
          Головна
        </Link>
        <div className={styles.setting_btn_wrapper} onClick={() => setShowGroupSetting(true)}>
          <SettingSvg />
        </div>
      </div>
      <div className={styles.content_wrapper}>
        {groups.length ? (
          <>
            <div className={styles.content_title}>{getGroupName(groups, group_id)}</div>

            <Link className={styles.btn_link} to={`/${pathHome}/menu/${group_id}`}>
              Меню
            </Link>
            <Link className={styles.btn_link} to={`/${pathHome}/participants/${group_id}`}>
              Учасники
            </Link>
            {/* <Link className={styles.btn_link} to={`/${pathHome}/control/${group_id}`}>
              Контроль
            </Link> */}
            <Link className={styles.btn_link} to={`/${pathHome}/group-activity/${group_id}`}>
              Активність
            </Link>
            <Link className={styles.btn_link} to={`/${pathHome}/statistics/${group_id}`}>
              Статистика
            </Link>

            <div className={styles.selected_date_wrapper}>
              <div className={!startDateGroup ? styles.selected_date_text_noActive : ''}>
                Дата старту групи
              </div>
              <input
                onChange={(e) => addDateStartGroup(e.target.value)}
                className={
                  startDateGroup
                    ? styles.selected_date_input
                    : styles.selected_date_input + ' ' + styles.selected_date_input_noActive
                }
                value={startDateGroup}
                type="date"
                name="date_start_group"
              />
            </div>

            <div className={styles.group_access_wrapper}>
              <div className={styles.group_id_wrapper}>
                <div>ID групи:</div>
                <div className={styles.group_id} onClick={() => copyGroupId(group_id)}>
                  {group_id}
                </div>
                {copyGroupIdTrue === group_id && (
                  <div className={styles.alertCopyTrue}>Скопійовано!</div>
                )}
              </div>
              <div className={styles.group_access_selected_wrapper}>
                <div>При реєстрації дає доступ до меню</div>
                <div
                  onClick={() => accessAll(group_id)}
                  className={
                    accessGroupAll
                      ? styles.group_access_selected_btn +
                        ' ' +
                        styles.group_access_selected_btn_active
                      : styles.group_access_selected_btn
                  }></div>
              </div>
            </div>

            <div className={styles.addLinksGroups_wrapper}>
              {/* Посилання на групу Viber
              <input
                className={styles.popup_input}
                type="text"
                value={viberGroupLink}
                onChange={(e) => setViberGroupLink(e.target.value)}
              /> */}
              Посилання на групу Telegram
              <input
                className={styles.popup_input}
                type="text"
                value={telegramGroupLink}
                onChange={(e) => setTelegramGroupLink(e.target.value)}
              />
              <button
                className={styles.save_btn}
                onClick={() =>
                  addLinksGroups({
                    viberGroupLink: viberGroupLink.trim(),
                    telegramGroupLink: telegramGroupLink.trim(),
                  })
                }>
                Зберегти
              </button>
            </div>
          </>
        ) : (
          <div>Пусто:)</div>
        )}
      </div>
      {shuowGroupSetting && (
        <GroupSetting setShowGroupSetting={setShowGroupSetting} group_id={group_id} />
      )}
      {loaderPage && <LoaderPage />}
    </>
  );
}
